import React from 'react'
import { Checkbox } from '@progress/kendo-react-inputs'
import { FieldWrapper } from '@progress/kendo-react-form'
import { TooltipHLPure } from './../index'
import './checkBox-template.css'

const CheckBoxTemplatePure = (props) => {
  const { showTooltip } = props

  return (
    < div className='container-checkBox' >
      <Checkbox className='style-checkbox' {...props} />
      {
        showTooltip && (
          <TooltipHLPure
            {...props}
          />
        )
      }
    </div >
  )
}

export { CheckBoxTemplatePure as default }
